import { connectStorageEmulator, getStorage } from "firebase/storage";
import { Buckets } from "@/constants";
import { app } from "./initialize-app";

export const storage = getStorage(app);
export const mediaStorage = getStorage(app, `gs://${Buckets.MEDIA}`);

// Connect to the Image Storage Emulator
process.env.NODE_ENV !== "production" &&
  process.env.NEXT_PUBLIC_FIREBASE_USE_EMULATOR === "true" &&
  connectStorageEmulator(mediaStorage, "0.0.0.0", 9199);

// Connect to the Storage Emulator
process.env.NODE_ENV !== "production" &&
  process.env.NEXT_PUBLIC_FIREBASE_USE_EMULATOR === "true" &&
  connectStorageEmulator(storage, "0.0.0.0", 9199);
